threat names multi select
<script setup lang="tsx">
import type { Response, Risk } from '@/models/api-generated'
import http from '@/services/http'
import { computed, onBeforeUnmount, ref } from 'vue'
import Multiselect from 'vue-multiselect'
import type { Column } from '@/stores/column'
import { commonProps } from '@/components/filter/props'
import ClearButton from '@/components/filter/ClearButton.vue'

const options = ref<string[]>([])
const isLoading = ref(false)
const isOpen = ref(false)
const props = defineProps(commonProps)

const model = defineModel<Column>({ required: true })
async function search(query: string) {
	isLoading.value = true

	const { data } = await http.get<Response<Risk[]>>('/api/risk/search', {
		params: { q: query },
	})

	options.value = (data.data || []).map((item) => item.name)

	isLoading.value = false
}

const internalModel = computed<string[]>({
	get: () => model.value.filter,
	set: (value) => {
		model.value.filter = value
	},
})

function handleOpen() {
	isOpen.value = true
	search('')
}

onBeforeUnmount(() => (model.value.filter = []))
</script>

<template>
	<Multiselect
		:multiple="true"
		:show-labels="false"
		:hide-selected="true"
		:close-on-select="false"
		:clear-on-select="false"
		:id="props.id"
		:disabled="props.disabled"
		:placeholder="model.label + '...'"
		:options="options"
		:preserve-search="true"
		:show-no-results="false"
		:loading="isLoading"
		v-model="internalModel"
		@search-change="search"
		@open="handleOpen"
		@close="isOpen = false"
		:limit="isOpen ? 100 : 3"
	>
		<template #clear>
			<ClearButton right="2rem" v-if="internalModel.length" @click="internalModel = []"></ClearButton>
		</template>

		<template v-if="!isOpen" #limit>
			<strong class="multiselect__strong">{{ $t('misc.limit', [internalModel.length - 3]) }}</strong>
		</template>
	</Multiselect>
</template>
